<template>
  <div id="login" class="row">
    <div class="page_text container">
      <div class="row csp-open-block csp-row-bot-h1r">
        <div class="csp-title-id col-xs-1 col-xs-offset-2"><span>Client Service Portal</span></div>
      </div>
      <div class="row csp-row-bot-1r">
        <div class=" csp-title-text col-xs-5  col-xs-offset-2"><span>Please login with your prefered account below.</span></div>
      </div>
      <div class="row">
        <div class="col-xs-8  col-xs-offset-2">
          <g-signin-button :params="googleSignInParams" @success="onGoogleSignInSuccess" @error="onGoogleSignInError" class="csp-login btn z-depth-3 goog-login">
            Log in with Google
          </g-signin-button>
        </div>
      </div> 
      <div class="row">
        <div class="col-xs-8  col-xs-offset-2">
          <fb-signin-button :params="facebookSignInParams" @success="onFacebookSignInSuccess" @error="onFacebookSignInError" class="csp-login btn z-depth-3 fb-login">
            Log in with Facebook
          </fb-signin-button>
        </div>
      </div> 
      <div class="row">
        <div class="col-xs-8  col-xs-offset-2">
          <amz-signin-button :params="amazonSignInParams" @success="onAmazonSignInSuccess" @error="onAmazonSigninError" class="csp-login btn z-depth-3 amz-login">
            Log in with Amazon
          </amz-signin-button>
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
  import {mapMutations, mapGetters, mapActions} from 'vuex'
  import amazonSignInButton from '../components/idp/Amazon'
  import facebookSignInButton from '../components/idp/Facebook'
  import googleSignInButton from '../components/idp/Google'

  export default {
    name: 'Login',
    components: {
      'amz-signin-button': amazonSignInButton,
      'fb-signin-button': facebookSignInButton,
      'g-signin-button': googleSignInButton
    },
    computed: {
      ...mapGetters([
        'amazonLoginEntry',
        'facebookLoginEntry',
        'googleLoginEntry',
        'amazonSignInParams',
        'facebookSignInParams',
        'googleSignInParams'
      ])
    },
    methods: {
      ...mapMutations([
        'onAmazonSigninError',
        'onFacebookSignInError',
        'onGoogleSignInSuccess',
        'onGoogleSignInError'
      ]),
      ...mapActions([
        'onAmazonSignInSuccess',
        'onFacebookSignInSuccess'
      ])
    },
    watch: {
      amazonLoginEntry: function (newVal) {
        console.log('Amazon login entry changed: %O', newVal)
        this.$store.dispatch('loginEntryChange', newVal)
      },
      facebookLoginEntry: function (newVal) {
        console.log('Facebook login entry changed: %O', newVal)
        this.$store.dispatch('loginEntryChange', newVal)
      },
      googleLoginEntry: function (newVal) {
        console.log('Google login entry changed: %O', newVal)
        this.$store.dispatch('loginEntryChange', newVal)
      }
    }
  }
</script>

<style scoped>

  .csp-login{
    width: 14rem;
    text-align:center;
    padding: 0.85rem 0.10em;
  }
  .amz-login{
    background-color: #ff9900;
  }
  .goog-login{
    background-color: #ff473a;
  }
  .fb-login{
    background-color: #3b5998;
  }
  
  .csp-open-block{
    margin-top: 15vh;
  }

  .csp-row-bot-1r{
    margin-bottom:1rem;
  }
  .csp-row-bot-h1r{
    margin-bottom:.5rem;
  }

  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// Login.vue?0f5ba73e